/**
 * How a field photo reads in the gallery and on the map.
 *
 * DataHog already ran OCR, a scene caption, and face matching. The list used
 * to throw all of that away and paint every pin teal. A watchlisted face is
 * the one case that has to look different from an anonymous snap with no id.
 */
import { MissionFieldReport } from '../../services/missionApi';

export const PHOTO_TEAL = '#41c4b6';
export const PHOTO_WATCH = '#f5b942';

export function photoAccent(report: MissionFieldReport): string {
  return report.watchlisted ? PHOTO_WATCH : PHOTO_TEAL;
}

export function photoTitle(report: MissionFieldReport): string {
  const named = (report.face_matches || []).map((n) => n.split(' (cluster')[0].trim()).find(Boolean);
  if (named) return named;
  const caption = (report.caption || report.scene || '').trim();
  if (caption) return caption;
  return (report.kind || 'Photo').trim() || 'Photo';
}

export function photoShortId(report: MissionFieldReport): string {
  if (report.identifier) return report.identifier.slice(0, 16);
  return (report.id || '').replace(/-/g, '').slice(0, 16);
}

export function photoDescription(report: MissionFieldReport): string {
  const caption = (report.caption || '').trim();
  const scene = (report.scene || '').trim();
  if (caption && scene && caption !== scene) return `${caption} · ${scene}`;
  return caption || scene;
}
